module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/20-b19a7481f4632726a70d9c6fa43f10b0.jpg";